// Packages
import tw, { styled } from 'twin.macro'

export const SearchContainer = styled.div(() => [
  tw`md:max-w-screen-md lg:max-w-screen-lg mx-auto text-white text-copy`,
])

export const SearchLabel = styled.label(() => [
  tw`pb-1 block md:pr-2 md:pb-0 mb-0.5 font-medium text-gray-700`,
])

export const InputWrapper = styled.div(() => [
  `position: relative;`,
  tw`flex items-center`,
])

export const InputIcon = styled.span(() => [
  `position: absolute; left: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;`,
])

export const SearchField = styled.input(() => [
  `
  :focus {
    outline: 1px dashed #fff;
    outline-offset: 3px;
  }
  `,
  `
  :hover {
    background-color: rgba(236, 237, 238, 0.7);
  }
  `,
  tw`text-black h-12 leading-10 w-full  md:h-12 pl-10 pr-10 bg-white rounded border border-[#ECEDEE]`,
])

export const ClearButton = styled.button(() => [
  `position: absolute; right: 10px; top: 50%; transform: translateY(-50%);`,
  `
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 2px;
  }
  `,
  tw`flex items-center justify-center w-6 h-6 cursor-pointer`,
])
